import { CapaRfqReviewType } from '@generated/graphql';
import { createReducer } from 'typesafe-actions';
import { INIT_REVIEW, UPDATE_REVIEW, UPDATE_REVIEW_RATING } from './actions';
import { Action, RfqReview } from './types';

export const initialState = {
  open: false,
  profileId: '',
  projectName: '',
  organizationName: '',
  reviewId: '',
  rfqId: '',
  quotationPartnerId: '',
  rfqReviewType: CapaRfqReviewType.OnlyTransaction,
  transactionSatisfactionPoint: 0,
  transactionSatisfactionComment: '',
  reviewFiles: [],
  inDueDate: true
};

export const review = createReducer<RfqReview, Action>(initialState, {
  [INIT_REVIEW]: () => {
    return initialState;
  },

  [UPDATE_REVIEW]: (state, action) => {
    return {
      ...state,
      ...action.payload
    };
  },

  [UPDATE_REVIEW_RATING]: (state, action) => {
    return {
      ...state,
      transactionSatisfactionPoint: action.payload
    };
  }
});
